import React from 'react';
import { createRoot } from 'react-dom/client';

import { Footer, Header } from './_scripts/common.jsx';

import './_styles/default.css';
import './index.css';

import gitHubIcon from './_images/social/GitHub.png';
import linkedInIcon from './_images/social/LinkedIn.png';
import logo from './_images/logo.png';


export const BREADCRUMBS = [{
    href: '/',
    rel: 'index',
    title: 'C. A. Hutton'
}];

export const ROOT = <div id="root">
    <Header current={BREADCRUMBS[0].href}/>
    <main id="homepage" itemScope itemType="http://schema.org/Person">
        <div>
            <h1 className="visuallyhidden">{BREADCRUMBS[BREADCRUMBS.length - 1].title}</h1>
            <meta itemProp="givenName" content="Corey"/>
            <meta itemProp="additionalName" content="A."/>
            <meta itemProp="familyName" content="Hutton"/>
            <meta itemProp="url" content="https://www.cahutton.com"/>
            <meta itemProp="email" content="cah@cahutton.com"/>
            <img src={logo} alt={''} fetchPriority='high'/>
        </div>
        <div>
            <a itemProp="sameAs" href="https://github.com/cahutton" target="_blank" rel="noopener" title="C. A. Hutton on GitHub">
                <img src={gitHubIcon} alt={'GitHub logo'}/>
            </a>
            <a itemProp="sameAs" href="https://www.linkedin.com/in/cahutton" target="_blank" rel="noreferrer" title="C. A. Hutton on LinkedIn">
                <img src={linkedInIcon} alt={'LinkedIn logo'}/>
            </a>
        </div>
    </main>
    <Footer breadcrumbs={BREADCRUMBS}/>
</div>;

const root = createRoot(document.getElementById('rootContainer'));
root.render(ROOT);
